window.dataLayer = window.dataLayer || [];

function _debounce(func, wait) {
  let timeout;

  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class MpbAnalytics {
    constructor() {
        this.isMobile = window.innerWidth < 768;

        this.lastDesktopMenuInteractionTime = 0;
        this.trackScroll();
        this.emailClickData();
        this.phoneClickData();
    }

    trackMenuClick(element) {
      try {
          let menuName = '';
          let subMenuName = '';

          // Check if it's a submenu item (has parent details)
          const parentDetails = element.closest('details');
          
          if (element.tagName === 'SUMMARY' || element.classList.contains('header__menu-item') && element.tagName === 'A' && !element.closest('.header__submenu')) {
              // Summary element or top-level menu link
              menuName = element.querySelector('span')?.textContent || '';
          } else if (element.closest('.header__submenu')) {
              // Submenu item
              subMenuName = element.textContent.trim();
              menuName = parentDetails?.querySelector('summary span')?.textContent || '';
          }

          if (window.Shopify?.analytics?.publish) {
              // Use setTimeout to defer the analytics call and avoid "already released" errors
              setTimeout(() => {
                  try {
                      Shopify.analytics.publish('header_menu_click', {
                          menu_name: menuName,
                          sub_menu_name: subMenuName
                      });
                  } catch (error) {
                      console.warn('Analytics publish error:', error);
                  }
              }, 0);
          }
      } catch (error) {
          console.warn('Menu click tracking error:', error);
      }
  }

      // 25%, 50%, 75%, 100% :: Debounce 100ms
  trackScroll() {
    let lastScrollTime = Date.now();
    window.addEventListener('scroll', _debounce(() => {
      const currentTime = Date.now();
      if(currentTime - lastScrollTime < 1000) return;
      lastScrollTime = currentTime;

      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;
      let finalPercentage = 0;
      
      if (scrollPercentage >= 25 && scrollPercentage < 50) {
        finalPercentage = 25;
      }
      if (scrollPercentage >= 50 && scrollPercentage < 75) {
        finalPercentage = 50;
      }
      if (scrollPercentage >= 75 && scrollPercentage < 100) {
        finalPercentage = 75;
      }
      if (scrollPercentage >= 90) {
        finalPercentage = 90;
      }

      if(finalPercentage > 0) {
        Shopify.analytics.publish('on_page_scroll', {
          scroll_percent: finalPercentage,
        });
      }
    }, 1000));
  }
    // email_click event
    emailClickData() {
        const self = this;
        document.addEventListener('click', function (event) {
            let target = event.target.closest('a[href^="mailto:"]');
            if (target) {
                let email_address = target.getAttribute('href').replace('mailto:', '');
                // dataLayer.push({
                //     event: self.eventPrefix + 'email_click',
                //     page_location: window.location.href,
                //     link_classes: target.getAttribute('class'),
                //     link_id: target.getAttribute('id'),
                //     email_address
                // })
                Shopify.analytics.publish('email_click', {
                    page_location: window.location.href,
                    link_classes: target.getAttribute('class'),
                    link_id: target.getAttribute('id'),
                    email_address
                });
            }
        });
    }
     // phone_number_click event
     phoneClickData() {
        const self = this; 
        document.addEventListener('click', function(event) {
          let target = event.target.closest('a[href^="tel:"]');
          if(target) {
            let phone_number = target.getAttribute('href').replace('tel:', '');
            Shopify.analytics.publish('phone_number_click', {
              page_location: window.location.href,
              link_classes: target.getAttribute('class'),
              link_id: target.getAttribute('id'),
              phone_number
            });
            // dataLayer.push({
            //   event: self.eventPrefix + 'phone_number_click',
            //   page_location: window.location.href,
            //   link_classes: target.getAttribute('class'),
            //   link_id: target.getAttribute('id'),
            //   phone_number
            // })
          }
        });
      }
}

document.addEventListener("DOMContentLoaded", function () {
    window.mpbAnalytics = new MpbAnalytics();
    /* ----------------------- Search Tracking -------------------------*/
    function pushSearchSuccess(inputElement) {
        const searchTerm = inputElement?.value || "";
        if (!searchTerm.trim()) return;

        Shopify.analytics.publish('on_search_success', {
            event: "search_success",
            searchTerm: searchTerm,
        });
    }

    // Predictive search
    const predictiveForm = document.querySelectorAll("form.search.search-modal__form");
    const predictiveResults = document.querySelector("#predictive-search-results");

    if (predictiveForm && predictiveResults) {
        predictiveForm.forEach((form) => {
            form.addEventListener("submit", () => {
                pushSearchSuccess(form.querySelector("input[type='search']"));
            });
        });

        let predictiveSearchTracked = false;
        const observerPredictive = new MutationObserver(() => {
            if (!predictiveSearchTracked) {
                predictiveForm.forEach((form) => {
                    pushSearchSuccess(form.querySelector("input[type='search']"));
                });

                predictiveSearchTracked = true;

                // Reset tracking flag after 2 seconds to allow new searches
                setTimeout(() => {
                    predictiveSearchTracked = false;
                }, 2000);
            }
        });

        observerPredictive.observe(predictiveResults, {
            childList: true,
            subtree: true
        });
    }
});